@if (meetingableId) {
  <app-meeting-record [meetingableType]="meetingableType" [meetingableId]="meetingableId" [meetingRecordId]="meetingRecordId">
  </app-meeting-record>
}
